import { getMenuUtilityClass, menuClasses as muiMenuClasses } from '@mui/material';

export const menuClasses = {
  ...muiMenuClasses,
  multiple: getMenuUtilityClass('multiple'),
};
